module.exports = __webpack_public_path__ + "assets/b5511ab62d5cea23585fe8b6a8ccdc52.png";